module.exports = __webpack_public_path__ + "static/img/aboutus_icon_mail@2x.8e6cd57.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/about/aboutus_icon_mail@2x.png
// module id = JzxE
// module chunks = 0